import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import { setStore, removeStore, store } from '../../../app/store';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import Modal from '../../../GlobalComponent/Modal'
import PopupDisplay from '../../../components/PopupDisplay';
import viewIcon from "../../../assets/img/view-icon.svg"
import arrowIcon from "../../../assets/img/arrow-left-02.svg"
// Use public paths for images in JSX
const galleryBanner = "/images/from-html/gallery-01.png";
const searchIcon = "/images/from-html/event-icon.svg";


const { REACT_APP_BRANDURL } = process.env;

// Add CSS for skeleton loader animation
const skeletonStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = skeletonStyles;
  document.head.appendChild(style);
}

export default function Gallery() {
  const [galleryData, setGalleryData] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCatagory, setShowCatagory] = useState(false);
  const [clickedImg, setClickedImg] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [FormData, setFormData] = useState({
    user_type: 'ALUMNI',
    username: '',
    password: ''
  });
  const store_data = JSON.parse(store());
  const [LoginStatus, setLoginStatus] = useState(0);
  const [HeroData, setHeroData] = useState(null);
  const [HeroLoading, setHeroLoading] = useState(true);

  // Fallback hero data for 'gallery' route
  const fallbackHeroData = {
    title: 'Together in Gallery',
    description: 'From a small group of ex-students meeting in Salt Lake in 1986 to a thriving alumni community today, the B E College Ex-Students\' Club has grown on the values of camaraderie, respect, and shared pride in our alma mater.',
    image: "/images/from-html/gallery-01.png",
    route: 'gallery'
  };

  // Fetch gallery data grouped by folders
  useEffect(() => {
    fetchGalleryData();
  }, []);

  // Fetch hero data for 'gallery' route
  useEffect(() => {
    fetchHeroData();
  }, []);

  const fetchHeroData = async () => {
    try {
      setHeroLoading(true);
      const response = await postAPI('hero-data/fetchData/gallery', {});

      console.log('Hero API Response:', response);

      if (response?.status === 1 && response?.data) {
        console.log('Hero data fetched:', response.data);
        setHeroData(response.data);
      } else {
        console.warn('Failed to fetch hero data, using fallback');
        setHeroData(fallbackHeroData);
      }
    } catch (error) {
      console.error('Error fetching hero data:', error);
      setHeroData(fallbackHeroData);
    } finally {
      setHeroLoading(false);
    }
  }

  const fetchGalleryData = async () => {
    try {
      setLoading(true);
      const response = await postAPI('gallery/listGroupedByFolder', {});
      if (response?.status === 1) {
        const data = response?.data || [];
        setGalleryData(data);
        // Extract unique folders for sidebar
        setFolders(data.map(item => ({
          id: item.folder_id,
          name: item.folder_name,
          count: item.file_count
        })));
      }
    } catch (error) {
      console.error('Error fetching gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  // Filter gallery data based on search and selected folder
  const filteredGalleryData = galleryData.filter(item => {
    const matchesSearch = searchQuery === '' ||
      item.folder_name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFolder = !selectedFolder || item.folder_id === selectedFolder;
    return matchesSearch && matchesFolder;
  });

  useEffect(() => {
    console.log(store_data)
    setLoginStatus(store_data?.is_login || 0)
  }, [store_data?.is_login || 0])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...FormData,
      [name]: value
    });
  }

  const handleLogin = async () => {
    try {
      // Validate form
      if (!FormData.username || !FormData.password) {
        setLoginStatus({ status: 0, msg: "Please enter username and password" });
        return;
      }

      setLoading(true);
      const response = await postAPI(`authentication/users/login`, FormData);

      console.log("Response : ", response?.data?.access_token)

      if (response?.status === 1) {
        setLoginStatus({ status: 1, msg: response?.msg });
        // Store access token and user data
        setStore({
          'is_login': response?.data?.is_login,
          'expiry': response?.data?.expiry,
          'access_token': response?.data?.access_token,
          'user_code': response?.data?.user_code,
          'user_type': response?.data?.user_type,
          'full_name': response?.data?.full_name,
          'email_id': response?.data?.email_id,
          'mobile_number': response?.data?.mobile_number,
        });

        // Reset form
        setFormData({
          username: '',
          password: ''
        });

        window.location.reload();
      } else {
        setLoginStatus({ status: 0, msg: response?.msg || "Login failed" });
      }
    } catch (e) {
      console.error('Login error:', e);
      setLoginStatus({ status: 0, msg: e.message || "An error occurred" });
    } finally {
      setLoading(false);
    }
  }

  const showCategoryHandel = () => {
    if (!showCatagory) {
      setShowCatagory(true);
    } else {
      setShowCatagory(false);
    }
  }

  const handleClick = (file, folderIndex, fileIndex) => {
    setCurrentIndex({ folderIndex, fileIndex });
    setClickedImg(file.file_url);
  };

  const handelRotationRight = () => {
    if (!currentIndex) return;

    const { folderIndex, fileIndex } = currentIndex;
    const files = galleryData[folderIndex].files;
    const totalLength = files.length;

    // Next index
    let nextIndex = fileIndex + 1;

    // Loop back to start
    if (nextIndex >= totalLength) nextIndex = 0;

    // Get next image
    const nextImg = files[nextIndex].file_url;

    setCurrentIndex({ folderIndex, fileIndex: nextIndex });
    setClickedImg(nextImg);
  };

  const handelRotationLeft = () => {
    if (!currentIndex) return;

    const { folderIndex, fileIndex } = currentIndex;
    const files = galleryData[folderIndex].files;
    const totalLength = files.length;

    // Previous index
    let prevIndex = fileIndex - 1;

    // Loop back to last
    if (prevIndex < 0) prevIndex = totalLength - 1;

    const prevImg = files[prevIndex].file_url;

    setCurrentIndex({ folderIndex, fileIndex: prevIndex });
    setClickedImg(prevImg);
  };

  useEffect(() => {
    console.log("Gallery Data", galleryData)
  }, [galleryData])

  return (
    <>
      <Header />
      <section className="hero-section">
        <div className="banner-image">
          {HeroLoading ? (
            <div style={{
              height: '500px',
              backgroundColor: '#e0e0e0',
              animation: 'pulse 1.5s infinite',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{ color: '#999' }}>Loading...</span>
            </div>
          ) : (
            <img
              src={HeroData?.backgroundImage ? (HeroData.backgroundImage.startsWith('http') ? HeroData.backgroundImage : `${process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/'}${HeroData.backgroundImage.startsWith('/') ? HeroData.backgroundImage.slice(1) : HeroData.backgroundImage}`) : fallbackHeroData.image}
              className="img-fluid"
              alt="banner"
              onError={(e) => { e.target.src = fallbackHeroData.image; }}
            />
          )}
        </div>
        <div className="hero-content">
          {HeroLoading ? (
            <>
              <div className="skeleton-loader" style={{ height: '60px', backgroundColor: '#e0e0e0', marginBottom: '20px', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
              <div className="skeleton-loader" style={{ height: '80px', backgroundColor: '#e0e0e0', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
            </>
          ) : (
            <>
              <h1
                className="fw-bold display-5"
              >
                {HeroData?.title || fallbackHeroData.title}
              </h1>
              <p
                className="mt-lg-3 mt-1 mb-0"
                style={{
                  color: HeroData?.descriptionColor || '#ffffff',
                  fontFamily: HeroData?.descriptionFont || 'Arial'
                }}
              >
                {HeroData?.description || fallbackHeroData.description}
              </p>
            </>
          )}
        </div>
      </section>
      <section className='inner-gallery'>
        <div className='container-fluid container-xxl'>
          <div className='row'>
            <div className='col-xl-3 col-lg-3'>
              <div className='category position-sticky mb-lg-0 mb-4'>
                <div className='d-flex align-items-center justify-content-between'>
                  <h3>Category</h3>
                  <button className='btn d-lg-none d-block' onClick={showCategoryHandel}><img src={arrowIcon} style={{ transform: showCatagory ? 'rotate(0deg)' : 'rotate(90deg)', transition: 'all 0.3s' }} /></button>
                  {/* <button className='btn d-lg-none d-block' onClick={showCategoryHandel}><img src="/images/from-html/map-icon.svg" /></button> */}
                </div>
                <ul className={showCatagory ? 'close' : 'show'}>
                  <hr></hr>
                  <li>
                    <a href='#all' className={!selectedFolder ? 'active' : ''} onClick={(e) => { e.preventDefault(); setSelectedFolder(null); }}>
                      <span>
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 0.5L5.2564 5.49999L0.5 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M4.15869 0.5L8.91509 5.49999L4.15869 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>All Categories
                    </a>
                  </li>
                  {folders.map((folder, index) => index < folders?.length - 1 && (
                    <li key={folder.id}>
                      <a
                        href={`#folder-${folder.id}`}
                        className={selectedFolder === folder.id ? 'active' : ''}
                        onClick={(e) => { e.preventDefault(); setSelectedFolder(folder.id); }}
                      >
                        <span>
                          <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 0.5L5.2564 5.49999L0.5 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.15869 0.5L8.91509 5.49999L4.15869 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>{folder.name}
                      </a>
                    </li>
                  ))}
                </ul>

              </div>
            </div>
            <div className='col-xl-9 col-lg-9'>
              <div className='d-flex align-items-center justify-content-between mb-3 flex-wrap'>
                <h3>All photos</h3>
              </div>
              <hr></hr>
              <div className='scroll-gallery'>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : filteredGalleryData && filteredGalleryData.length > 0 ? (
                  filteredGalleryData.map((folder, folderIndex) => (
                    <div key={folderIndex} id={`folder-${folder.folder_id}`} className="img-panel mb-5">
                      <div className='d-flex align-items-center justify-content-lg-between justify-content-md-between justify-content-sm-between justify-content-center mb-3 flex-wrap'>
                        <h4>{folder.folder_name}</h4>
                        <div className='date'>
                          {formatDate(folder.latest_date)} <span>{folder.file_count} photos</span>
                        </div>
                      </div>
                      {console.log("folder, folderIndex", folder, folderIndex)}
                      <div className='row'>
                        {folder.files && folder.files.length > 0 && (
                          <>
                            {/* First image - large */}
                            <div className='col-lg-5 col-md-4'>
                              <div href='#' className='gallery-item img-big'>
                                <img
                                  src={`${folder.files[0].file_url}`}
                                  className='img-fluid'
                                  alt={folder.files[0].gallery_file_name || 'Gallery image'}
                                />
                                <div className="overlay" onClick={() => handleClick(folder.files[0], folderIndex, 0)}>
                                  <span className="plus-icon">
                                    <img src={viewIcon} alt="view" />
                                  </span>
                                  <div className="img-info">
                                    {/* <small>{formatDate(folder.files[0].createdAt)}</small> */}
                                    <h6 className="mb-0">{folder.files[0].gallery_file_name || folder.folder_name}</h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* Remaining images - small grid */}
                            <div className='col-lg-7 col-md-8'>
                              <div className='row'>
                                {folder.files.slice(1).map((file, fileIndex) => (
                                  <div key={fileIndex} className='col-lg-6 col-md-6'>
                                    <div href='#' className='gallery-item img-small mb-3'>
                                      <img src={`${file.file_url}`} className='img-fluid' alt={file.gallery_file_name || 'Gallery image'} />
                                      <div className="overlay"
                                        onClick={() => handleClick(file, folderIndex, fileIndex + 1)}
                                      >
                                        <span className="plus-icon">
                                          <img src={viewIcon} alt="view" />
                                        </span>
                                        <div className="img-info">
                                          {/* <small>{formatDate(file.createdAt)}</small> */}
                                          <h6 className="mb-0">{file.gallery_file_name || folder.folder_name}</h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <p>No gallery images found</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {clickedImg && (
        <Modal
          clickedImg={clickedImg}
          handelRotationRight={handelRotationRight}
          setClickedImg={setClickedImg}
          handelRotationLeft={handelRotationLeft}
        />
      )}
      <PopupDisplay currentPage="gallery" />
    </>
  )
}
